import { render } from "./App.vue?vue&type=template&id=151f368a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=151f368a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__